module.exports = __webpack_public_path__ + "img/type16.00b41e3e.png";